import React, {Component, useState, useEffect, Fragment } from 'react';
import { Message } from "element-react";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
// import './detail.scss';
import $ from 'jquery';
import classNames from 'classnames';
import API from '../../../config/api';
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import { Slider, WingBlank, WhiteSpace } from 'antd-mobile';
import gb from '../../../assets/gb.png'
import dk from '../../../assets/dk.png'
const DETAIL_TYPE = {
  PICTEXT: 'PICTEXT', // 图文
  VIDEO: 'VIDEO', // 视频
  SWIPER: 'SWIPER' // 图说
}
var setin = null;
class Audio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: '',
      data: {}, // 稿件数据，初始化为空对象防止首次渲染报错
      //notStarted：未开始 start：开始 suspend：暂停 end：结束
      stateName: 'notStarted',
      titleSwitch: false,
    }
  }
  componentWillMount() {
    const {data} = this.props;
    this.setState({
      data,
    }, () => {
      let urlname = this.state.data.ext_data && this.state.data.ext_data.audio_url || '';
      // console.log(this.state.data.ext_data.audio_url)
      this.aliPla(urlname)
      document.title = data.title;
      this.setState({
        title: data.title,
        desc: data.desc,
      })
    })
  }
  
  componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    console.log(nextProps)
    setin && clearInterval(setin)
  }
  componentWillUnmount() {
    setin&&clearInterval(setin)
  }
  aliPla(url) {
    console.log(123)
    var _this = this
    var player = new window.Aliplayer({
      "id": "J_prismPlayer",
      // "source": 'https://bjdc-test.oss-cn-beijing.aliyuncs.com/audio/2023/06/14/5332983622616461779.mp3',
      "source": url,
      "width": "0px",
      "height": "0px",
      "autoplay": false,
      "isLive": false,
      "rePlay": false,
      "playsinline": true,
      "preload": true,
      "controlBarVisibility": "hover",
      "useH5Prism": true,
      "mediaType": "audio"
    }, function (player) {
        window.player_getDur = player.getDuration();
    });
    this.setState({
      playerName: player
    })
    // player.play();
    // return window.player
    player.on('ready', function(e) {
      // player.play();
      var player_getDur = player.getDuration();
      var ddd=Math.floor(player_getDur%3600);
      //  Math.floor(getCurrentTime/3600) + "时" + 
      var fff =Math.floor(ddd/60) + ":"+ (Math.round(player_getDur%60) < 10 ? '0' + Math.round(player_getDur%60) : Math.round(player_getDur%60));
      document.getElementsByClassName('in_tuola_right')[0].innerText = fff;
    });
    player.on("ended", function(e){
        const {stateName} = _this.state;
        // if(stateName === 'notStarted'){
          _this.setState({
            stateName: 'end'
          })
        // }else if(stateName === 'start'){
        //   this.setState({
        //     stateName: 'suspend'
        //   })
        // }else {
        //   this.setState({
        //     stateName: 'start'
        //   })
        // }
        setin&&clearInterval(setin)
        var player_getDur = player.getDuration();
        // console.log(player_getDur)
        var cdf=Math.floor(player_getDur%3600);
        //  Math.floor(getCurrentTime/3600) + "时" + 
        var fcc =Math.floor(cdf/60) + ":"+ (Math.round(player_getDur%60) < 10 ? '0' + Math.round(player_getDur%60) : Math.round(player_getDur%60));
        $('.in_tuola_left').innerText = fcc
        $('.in_tuola_jindu_xian').css('width',"4.96rem");
        $('.in_tuola_jindu_dian').css('left',"4.96rem");
    })
  }
  // 音频稿件
    // 音频开始
    audioStart = () => {
      var _this = this
      this.state.playerName && this.state.playerName.play()
      const {stateName} = this.state;
      if(stateName === 'notStarted'){
        this.setState({
          stateName: 'start'
        })
      }else if(stateName === 'start'){
        this.setState({
          stateName: 'suspend'
        })
      }else {
        this.setState({
          stateName: 'start'
        })
      }
      
      
      setin = setInterval(function(){
        // var getCurrentTime = player.getCurrentTime()
        var getCurrentTime = _this.state.playerName.getCurrentTime && _this.state.playerName.getCurrentTime()

        // var in_tuola_jindu_dian = document.getElementsByClassName('in_tuola_jindu_dian')[0];
        // var in_tuola_jindu_xian = document.getElementsByClassName('in_tuola_jindu_xian')[0];
        var obj = document.getElementsByTagName('html')[0];
        var font_si = parseFloat(window.getComputedStyle(obj, '').getPropertyValue("font-size"));
        var width = $('.in_tuola_jindu').width() - 6;

        // console.log(getCurrentTime)
        var min=Math.floor(getCurrentTime%3600);
        //  Math.floor(getCurrentTime/3600) + "时" + 
        // var fenm =Math.floor(min/60) + ":"+ (Math.floor(getCurrentTime%60) < 10 ? '0' + Math.floor(getCurrentTime%60) : Math.floor(getCurrentTime%60));
        var fenm =Math.floor(min/60) + ":"+ (Math.round(getCurrentTime%60) < 10 ? '0' + Math.round(getCurrentTime%60) : Math.round(getCurrentTime%60));
        document.getElementsByClassName('in_tuola_left')[0].innerText = fenm;
        // console.log(fenm)
        // var getC_pla = getCurrentTime / window.player_getDur * 100 ;
        var getC_pla = getCurrentTime / _this.state.playerName.getDuration() * 100 ;
        document.getElementsByClassName('in_tuola_jindu_xian')[0].style.width = (width * getC_pla / 100 / font_si) +'rem';
        document.getElementsByClassName('in_tuola_jindu_dian')[0].style.left = (width * getC_pla / 100 / font_si) +'rem';
        // $('.in_tuola_jindu_xian').width(width*getC_pla/100);
        // $('.in_tuola_jindu_dian').css({
        //     left: width*getC_pla/100
        // });
    },1000)
  }
  // 音频暂停
  audioSuspend = () => {
    this.state.playerName && this.state.playerName.pause();
    setin&&clearInterval(setin)
    const {stateName} = this.state;
    if(stateName === 'notStarted'){
      this.setState({
        stateName: 'start'
      })
    }else if(stateName === 'start'){
      this.setState({
        stateName: 'suspend'
      })
    }else {
      this.setState({
        stateName: 'start'
      })
    }
  }
  // 将富文本中的a标签链接替换为当前环境的链接
  replaceHref() {
    console.log("888888888")
    for (var i = 0; i < $('a').length; i++) {
      var href = $($('a')[i]).attr('href')
      if (href.indexOf('type=') > -1 && href.indexOf('uuid=') > -1) {
        //替换
        var array = href.split('&');
        var obj = {};
        for (var j = 0; j < array.length; j++) {
          var arr = array[j].split('=');
          obj[arr[0]] = arr[1]
        }
        var new_href = API.host + '/index.html#/';
        switch (obj.type) {
          case 'article': // 文章
            new_href += 'detail/1/' + obj.uuid;
            break;
          case 'video': // 视频
            new_href += 'detail/2/' + obj.uuid + '/2';
            break;
          case 'live': // 直播
            new_href += 'detail/2/' + obj.uuid + '/6';
            break;
          case 'imageSays': // 图说
            new_href += 'detail/3/' + obj.uuid;
            break;
          case 'normalSpecial': // 常规专题
            new_href += 'subject/1/' + obj.uuid;
            break;
          case 'timeLineSpecial': // 时间线专题
            new_href += 'subject/2/' + obj.uuid;
            break;
          case 'newSpecial': // 新型专题
            new_href += 'newSubject' + obj.uuid;
            break;
        }
        $($('a')[i]).attr('href', new_href)
      }
    }
  }
  titleSwitchFun = () => {
    const {titleSwitch} = this.state;
    this.setState({
      titleSwitch: !titleSwitch
    })
  }
  render() {
    const {uuid, data, audioDuration, audioCurTime, audioPlayStatus, playSpeedAry, curSelectSpeed, curSwiperText, curSwiperIndex, stateName, titleSwitch} = this.state;
    return (
      <Fragment>
        <div style={{color:'#hsl(16.34deg 88.89% 50.59%)',fontSize:'14px', backgroundColor:'hsl(60deg 100% 50.2%)', padding:'10px 0px', textAlign:'center'}}>内部使用，请勿外传</div>
        <div className="audio-box">
          <div className="vid_top" style={{
            backgroundImage: 'url(' + data.cover + ')', backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat'
          }}>
            <div className="in_top">
              <div className={"in_bai_z " + (stateName === 'notStarted' || stateName === 'suspend' || stateName === 'end' ? 'in_bai_z_jiaozheng' : stateName === 'start' ? 'in_bai_z_jiao' : '')}></div>
              <div className="in_top_xian">
                <div className={"in_top_changp " + (stateName === 'start' ? 'in_xuanz_cp' : 'in_xuanz_cp pause')}>
                </div>
                {stateName === 'notStarted' || stateName === 'suspend' ? <div className="in_top_bf" onClick={this.audioStart}></div> : ''}
                {stateName === 'start' ? <div className="in_top_zt" onClick={this.audioSuspend}>
                  <div className="in_top_zt_dx lundong_cla"></div>
                </div> : ''}

                {stateName === 'end' ? <div className="in_top_cb" onClick={this.audioStart}></div> : ''}
              </div>
            </div>
            <div className="prism-player" id="J_prismPlayer" style={{ display: 'none' }}></div>
            <div className="in_tuola">
              <div className="in_tuola_left">0:00</div>
              <div className="in_tuola_cen">
                <div className="in_tuola_jindu">
                  <div className="in_tuola_jindu_xian"></div>
                  <div className="in_tuola_jindu_dian"></div>
                </div>
              </div>
              <div className="in_tuola_right"></div>
            </div>
          </div>

          <div className="min">
            <div className="box_title">
              <div style={{ fontWeight: '700' }} onClick={this.titleSwitchFun}>{data.title}</div><div className="anniu"><img className={!titleSwitch ? 'gb' : ''} src={gb} alt="" /><img className={titleSwitch ? 'gb' : ''} src={dk} alt="" /></div>
            </div>
            <div className="box_jizhe">
              <span className="authortt">{data.head_author} </span>
            </div>
            <div className="article_s" style={!titleSwitch ? { display: 'none' } : {}}>
              <p>{data.desc}</p>
            </div>

          </div>

        </div>
      </Fragment>
    )
  }
}
export default Audio



// WEBPACK FOOTER //
// ./src/pages/Preview/Audio/audio.js